(function() {
    'use strict';

    angular.module('blocks.storage', ['blocks.logger', 'ngStorage']);
})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/blocks/storage/storage.module.js
 ** module id = 95
 ** module chunks = 0
 **/